/* ========================================================================
   zy-product-card.js — Phase 5 bugfix, v2.
   The first fix attempt (replacing cart-drawer-component's innerHTML
   before calling open()) broke the native <dialog> element entirely
   (InvalidStateError: showModal on a detached node) -- reverted.
   Safer fix: fetch the cart JSON (which we already do for the item
   count) and wait for it to resolve, then give the native component one
   more animation frame before calling its own open() untouched. This
   does not modify the component's internal DOM at all, so it can't break
   its internal element references the way the first attempt did.
   ======================================================================== */
(function () {
  function getLiveRegion() {
    var el = document.getElementById('zy-live-region');
    if (!el) {
      el = document.createElement('div');
      el.id = 'zy-live-region';
      el.className = 'zy-sr-live';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    return el;
  }
  function announce(msg) {
    var el = getLiveRegion();
    el.textContent = '';
    setTimeout(function () { el.textContent = msg; }, 30);
  }
  window.zyAnnounce = announce;

function openCartDrawer() { var drawer = document.querySelector('cart-drawer-component'); if (!drawer || typeof drawer.open !== 'function') return; function openWhenReady(el) { if (!el || typeof el.open !== 'function') return; requestAnimationFrame(function () { requestAnimationFrame(function () { el.open(); }); }); } var sectionEl = drawer.closest('[id^="shopify-section-"]'); var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null; var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; if (!sectionId) { openWhenReady(drawer); return; } fetch(root + '?sections=' + encodeURIComponent(sectionId)).then(function (r) { if (!r.ok) throw new Error('section fetch failed'); return r.json(); }).then(function (data) { var html = data && data[sectionId]; if (!html) { openWhenReady(drawer); return; } var doc = new DOMParser().parseFromString(html, 'text/html'); var freshDrawer = doc.querySelector('cart-drawer-component'); if (freshDrawer && drawer.parentNode) { drawer.parentNode.replaceChild(freshDrawer, drawer); openWhenReady(freshDrawer); } else { openWhenReady(drawer); } }).catch(function () { openWhenReady(drawer); }); } window.zyOpenCartDrawer = openCartDrawer;

  function addToCart(variantId, btn) {
    btn.disabled = true;
    btn.dataset.state = 'loading';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) { throw new Error('Add to cart failed'); }
        return r.json();
      })
      .then(function (item) {
        btn.dataset.state = 'added';
        announce((item && item.product_title ? item.product_title : 'Item') + ' added to cart.');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        openCartDrawer();
        setTimeout(function () {
          btn.dataset.state = '';
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.dataset.state = 'error';
        announce('Sorry, that item could not be added to your cart.');
        setTimeout(function () {
          btn.dataset.state = '';
          btn.disabled = false;
        }, 1500);
      });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-zy-quick-add]');
    if (!btn || btn.disabled) return;
    ev.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    addToCart(variantId, btn);
  });
})();
